<template>
  <span class="pretty-time">
    {{ prettyTime }}
  </span>
</template>

<script>
export default {
  name: 'PrettyTime',
  props: {
    seconds: { default: 0 },
    showZero: { default: false },
    decimalHours: { default: null }
  },
  computed: {
    useDecimalHours () {
      if (this.decimalHours === true || this.decimalHours === false) {
        return this.decimalHours
      } else {
        return this.$store.getters.settings.decimalHours.value
      }
    },
    prettyTime () {
      if (!this.seconds || window.isNaN(this.seconds)) {
        return this.showZero ? '0' : ''
      }
      let minutes = Number(this.seconds) / 60
      if (this.useDecimalHours) {
        let hours = minutes / 60
        hours = Math.round(hours * 100) / 100
        return `${hours}`
      } else {
        let hours = Math.floor(minutes / 60)
        minutes = Math.round(minutes % 60)
        return `${hours}:${minutes === 0 ? '00' : minutes < 10 ? `0${minutes}` : `${minutes}`}`
      }
    }
  }
}
</script>
